import { InfoIcon } from 'lucide-react'

import { VideoTutorials } from '@/entities/video-tutorial'

import { PageNavigatorRegister } from '@/shared/components/PageNavigator'
import { Button } from '@/shared/components/ui/button'
import { Content, Layout } from '@/shared/components/ui/layout'
import {
	ResizableHandle,
	ResizablePanel,
	ResizablePanelGroup,
} from '@/shared/components/ui/resizable'
import { SidebarProvider } from '@/shared/components/ui/sidebar'
import { VideoTag } from '@/shared/generated'

import { ScenariosContent } from './ScenariosContent'
import { ScenariosHeader } from './ScenariosHeader'
import { ScenariosProvider } from './ScenariosProvider'
import { ScenariosSidebar } from './ScenariosSidebar'

export default function ScenariosPage() {
	return (
		<ScenariosProvider>
			<ScenariosHeader />
			<SidebarProvider className='min-h-0 flex-1 items-start'>
				<ResizablePanelGroup direction='horizontal' className='h-full'>
					<ResizablePanel
						defaultSize={20}
						minSize={15}
						maxSize={40}
						className='flex flex-col'
					>
						<ScenariosSidebar />
					</ResizablePanel>
					<ResizableHandle withHandle />
					<ResizablePanel defaultSize={80} minSize={60}>
						<Layout row className='h-full overflow-hidden'>
							<PageNavigatorRegister>
								<VideoTutorials tags={[VideoTag.WhatIf]}>
									<Button size='icon' className='ml-auto' variant='ghost'>
										<InfoIcon />
									</Button>
								</VideoTutorials>
							</PageNavigatorRegister>
							<Content className='relative w-full flex-col overflow-y-auto'>
								<ScenariosContent />
							</Content>
						</Layout>
					</ResizablePanel>
				</ResizablePanelGroup>
			</SidebarProvider>
		</ScenariosProvider>
	)
}
